<template>
    <div>
        <b-navbar
            id="notification-header"
            v-if="show_notification && !isHasSubscriptionMessage"
            :class="notiClass"
        >
            <b-nav-text :class="notiClass" class="mr-auto ml-auto pt-0 pb-0">
                <i
                    :class="{
                        'cus-exclamation':
                            variant == 'danger' || variant == 'error',
                        'cus-error': variant == 'warning',
                        'cus-information': variant == 'info'
                    }"
                ></i>
                <span
                    v-html="message"
                    :class="{
                        'text-danger':
                            variant == 'danger' || variant == 'error',
                        'alert-warning': variant == 'warning',
                        'text-info': variant == 'info'
                    }"
                ></span>
            </b-nav-text>
            <b-nav-item @click.prevent="close" class="float-right" href
                >&times;</b-nav-item
            >
        </b-navbar>
    </div>
</template>
<style lang="scss">
#notification-header span a {
    font-weight: normal;
    text-decoration: none;
    color: #0088cc;
}

#notification-header {
    list-style-type: none;

    // --removed old object
    a.btn.btn-primary {
        display: none;
    }
}

@media (min-width: 992px) {
    #notification-header {
        position: fixed;
        width: 100%;
        z-index: 1003;
    }
}
</style>
<script>
export default {
    props: {
        isHasSubscriptionMessage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show_notification: false,
            message: "",
            variant: "",
            loading: false
        };
    },
    computed: {
        notiClass() {
            let label = "";
            switch (this.variant) {
                case "error":
                    label = "alert-danger";
                    break;
                default:
                    label = "alert-" + this.variant;
                    break;
            }

            return label;
        }
    },
    watch: {
        show_notification() {
            this.$emit("visible");
        }
    },
    mounted() {
        this.notify();
    },
    methods: {
        notify() {
            let self = this;
            let storageKey = "in-apps-notication";

            return this.$http
                .get(
                    process.env.BARRACUDA + "communication/in-apps-notification"
                )
                .then(function (response) {
                    if (
                        response.data.response.resource &&
                        response.data.response.resource.message &&
                        response.data.response.resource.message.length > 0
                    ) {
                        self.show_notification = true;
                        self.message = response.data.response.resource.message;
                        self.variant = response.data.response.resource.variant;
                        let notificationId =
                            response.data.response.resource.notification_id;

                        if (localStorage.getItem(storageKey) === null) {
                            if (notificationId) {
                                localStorage.setItem(
                                    storageKey,
                                    JSON.stringify({
                                        status: 1,
                                        id: notificationId,
                                        message: self.message
                                    })
                                );
                            }
                        } else {
                            let data = JSON.parse(
                                localStorage.getItem(storageKey)
                            );

                            if (data.status === 0) {
                                self.show_notification = false;
                            }

                            if (notificationId) {
                                if (data.id != notificationId) {
                                    localStorage.setItem(
                                        storageKey,
                                        JSON.stringify({
                                            status: 1,
                                            id: notificationId,
                                            message: self.message
                                        })
                                    );
                                    self.show_notification = true;
                                }
                            } else {
                                if (localStorage.getItem(storageKey) !== null) {
                                    localStorage.removeItem(storageKey);
                                }
                            }
                        }
                    }
                });
        },
        close() {
            let storageKey = "in-apps-notication";
            let data = JSON.parse(localStorage.getItem(storageKey));
            data.status = 0;
            localStorage.setItem(storageKey, JSON.stringify(data));

            this.show_notification = false;
        }
    }
};
</script>
